import { Api } from '@/munio/api/base.js'

class CompanyCharts extends Api<{ company: number }> {
  constructor(companyId: number) {
    super({
      company: companyId,
    })
  }

  users() {
    return this.$get(this.$route('api.web.admin.company.charts.users'))
  }

  completions() {
    return this.$get(this.$route('api.web.admin.company.charts.completions'))
  }
}

export default CompanyCharts
